import React, { useMemo } from "react";
import { HStack, Text, Tooltip } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

/**
 * Renders the gearbox card
 * 
 * @param {Object} props The props of the component
 * @returns The gearbox card
 */
const GearboxCard = ({ vehicle }) => {
  const { t } = useTranslation();
  const vehicleGearBox = useMemo(
    () => vehicle?.Vehicle?.Powertrain?.Transmission?.Type?.toLowerCase(),
    [vehicle?.Vehicle?.Powertrain?.Transmission?.Type],
  );

  return (
    <Tooltip
      hasArrow={true}
      label={t("plugin.tooltips.gearbox", {
        gearbox: t(
          `plugin.gearBox.type.${vehicleGearBox || "unknown"}`,
        ).toLowerCase(),
      })}
      placement={"right"}
    >
      <HStack flexGrow={1} alignItems={"center"} justifyContent={"flex-end"} gap={"5px"}>
        <Text
          color={"white"}
          alignSelf={"flex-start"}
          fontWeight={500}
          fontSize={"14px"}
        >
          P
        </Text>
        <Text alignSelf={"flex-start"}
          fontWeight={500}
          fontSize={"14px"}
          color={"#B8BCBD"}>
          R
        </Text>
        <Text alignSelf={"flex-start"}
          fontWeight={500}
          fontSize={"14px"}
          color={"#B8BCBD"}>
          N
        </Text>
        <Text alignSelf={"flex-start"}
          fontWeight={500}
          fontSize={"14px"}
          color={"#B8BCBD"}>
          D
        </Text>
      </HStack>
    </Tooltip>
  );
};

export default React.memo(GearboxCard);
